import { render, staticRenderFns } from "./newUserModal.vue?vue&type=template&id=236a6c60&scoped=true&"
import script from "./newUserModal.vue?vue&type=script&lang=js&"
export * from "./newUserModal.vue?vue&type=script&lang=js&"
import style0 from "./newUserModal.vue?vue&type=style&index=0&id=236a6c60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236a6c60",
  null
  
)

component.options.__file = "newUserModal.vue"
export default component.exports